var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderBookAskDarkmodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 9C18.0005 13.9706 13.9711 18 9.00052 18C9.00012 12.375 9.00027 13.9706 9.00027 9C9.00027 4.02944 9.00027 6.1875 9.00052 0C13.9711 0 18.0005 4.02944 18.0005 9Z",
    fill: "#C1C4C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.69549e-06 9C-3.69549e-06 13.9706 4.02943 18 9 18C9.00039 12.375 9.00024 13.9706 9.00024 9C9.00024 4.02944 9.00024 6.1875 9 0C4.02943 0 -3.69549e-06 4.02944 -3.69549e-06 9Z",
    fill: "#4ECC79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderBookAskDarkmodeIcon);
export default __webpack_public_path__ + "static/media/order-book-ask-darkmode-icon.6e43c76cec09655531724be405b4db1c.svg";
export { ForwardRef as ReactComponent };